import type { ActiveOrderNanodrop } from '@/resources/types'
import { createContext, useContext } from 'react'

export type ActiveOrdersNanodropContextType = {
  activeOrdersNanodrop: ActiveOrderNanodrop[]
  isQueryFetching: boolean
  isFetched: boolean
  refetch: () => void
}

export const ActiveOrdersNanodropContext =
  createContext<ActiveOrdersNanodropContextType>({
    activeOrdersNanodrop: [],
    isQueryFetching: false,
    isFetched: false,
    refetch: () => undefined,
  })

const useActiveOrdersNanodropContext = () => {
  const context = useContext(ActiveOrdersNanodropContext)
  if (!context) {
    throw new Error(
      'useActiveOrdersNanodropContext must be used within ActiveOrdersNanodropProvider'
    )
  }
  return context
}

export default useActiveOrdersNanodropContext
